/* Puschies (1:1 aus CallMePuppy): Land- und Sprachauswahl + Länder-Pop-up „Land & Sprache bestätigen“ (#p-lconf)
   bzw. alter einmaliger Sprach-Hinweis (Markup: snippets/p-localization.liquid, Logik: assets/p-loc-confirm-logic.js).
   Keine Texte im JS: alles kommt aus dem Liquid-Markup (locales) bzw. per Section Rendering API. ES-Modul (Import-Map). */

import {
  parseCountryLanguages, languagesFor, isDachCountry, pickCountry as pickConfCountry, pickLanguage, isExcludedPath, isBot,
  shouldShow, freeShipping, fillTemplate, confirmToken, targetPath, localeCode, parseConfirmToken,
} from '@theme/p-loc-confirm-logic';

(function () {
  var modal = document.getElementById('p-loc');
  var form = document.getElementById('p-loc-form');
  if (!modal || !form) return;
  var hint = document.getElementById('p-lhint');
  var conf = document.getElementById('p-lconf');
  var CONF_KEY = 'p-loc-confirmed';
  var SHOWN_KEY = 'p-loc-shown';
  var confPrevFocus = null;
  var KEY = 'p-lang-choice';
  var root = document.documentElement;
  var curCountry = modal.getAttribute('data-country');
  var curLang = modal.getAttribute('data-lang');
  var panel = modal.querySelector('.p-loc__panel');
  var backBtn = modal.querySelector('[data-p-loc-back]');
  var stepCountry = modal.querySelector('[data-step="country"]');
  var stepLang = modal.querySelector('[data-step="language"]');
  var langGrid = modal.querySelector('[data-p-loc-langs]');
  var openEl = null;
  var lastFocus = null;
  var picked = null;

  // Fixed-Overlays direkt ans <body> (nicht in Section-Containern mit transform/overflow stecken lassen)
  [modal, hint, conf].forEach(function (el) { if (el && el.parentElement !== document.body) document.body.appendChild(el); });

  function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function remembered() { try { return localStorage.getItem(KEY); } catch (e) { return 'blocked'; } }

  function focusables(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll('button, [href], input, select, [tabindex]:not([tabindex="-1"])'),
      function (n) { return !n.disabled && n.offsetParent !== null; }
    );
  }

  function open(el, focusTarget) {
    if (openEl && openEl !== el) close(openEl, true);
    lastFocus = document.activeElement;
    openEl = el;
    el.hidden = false;
    root.classList.add('p-loc-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    var f = focusTarget || focusables(el)[0];
    if (f) f.focus({ preventScroll: true });
  }

  function close(el, keepLock) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    if (openEl === el) openEl = null;
    if (!keepLock) root.classList.remove('p-loc-lock');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 250);
    if (!keepLock && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  function showStep(lang) {
    stepCountry.hidden = lang;
    stepLang.hidden = !lang;
    backBtn.hidden = !lang;
    panel.setAttribute('aria-labelledby', lang ? 'p-loc-t-language' : 'p-loc-t-country');
    panel.scrollTop = 0;
    var cur = (lang ? stepLang : stepCountry).querySelector('.p-loc__opt[aria-current="true"]:not([hidden])');
    var first = cur || (lang ? stepLang : stepCountry).querySelector('.p-loc__opt:not([hidden])');
    if (first) first.focus({ preventScroll: true });
  }

  function submit(country, lang) {
    remember(lang || curLang);
    if (country === curCountry && (!lang || lang.toLowerCase() === curLang)) { close(openEl); return; }
    form.elements.country_code.value = country;
    if (lang) form.elements.language_code.value = lang;
    form.submit();
  }

  function pickCountry(btn) {
    picked = btn.getAttribute('data-p-loc-country');
    var langs = (btn.getAttribute('data-langs') || '').split(',').filter(Boolean);
    if (langs.length < 2) {
      var only = langs[0] && langGrid.querySelector('[data-p-loc-lang="' + langs[0] + '"]');
      submit(picked, only ? only.getAttribute('data-code') : null);
      return;
    }
    // Sprachen des Landes in Zuordnungs-Reihenfolge zeigen, übrige ausblenden
    Array.prototype.forEach.call(langGrid.children, function (b) { b.hidden = true; b.removeAttribute('aria-current'); });
    langs.forEach(function (code) {
      var b = langGrid.querySelector('[data-p-loc-lang="' + code + '"]');
      if (!b) return;
      b.hidden = false;
      if (code === curLang) b.setAttribute('aria-current', 'true');
      langGrid.appendChild(b);
    });
    showStep(true);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var opener = t.closest('[data-p-loc-open]');
    if (opener) {
      e.preventDefault();
      showStep(false);
      open(modal, stepCountry.querySelector('.p-loc__opt[aria-current="true"]'));
      return;
    }
    if (!openEl) return;
    if (t.closest('[data-p-loc-close]')) { close(modal); return; }
    if (t.closest('[data-p-loc-back]')) { showStep(false); return; }
    var c = t.closest('[data-p-loc-country]');
    if (c) { pickCountry(c); return; }
    var l = t.closest('[data-p-loc-lang]');
    if (l) { submit(picked || curCountry, l.getAttribute('data-code')); return; }
    if (conf && openEl === conf) {
      if (t.closest('[data-p-lconf-close]')) { confirmCurrent(); return; }
      if (t.closest('[data-p-lconf-ok]')) { confirmSelection(); return; }
      if (t.closest('[data-p-lconf-other]')) {
        markConfirmed(confirmToken(curCountry, curLang));
        close(conf, true);
        showStep(false);
        open(modal, stepCountry.querySelector('.p-loc__opt[aria-current="true"]'));
        lastFocus = confPrevFocus;
        return;
      }
    }
    if (t.closest('[data-p-lhint-stay]')) { remember(curLang); close(hint); return; }
    if (t.closest('[data-p-lhint-switch]')) { submit(curCountry, hint.getAttribute('data-code')); }
  });

  // Capture-Phase: ESC schließt nur diesen Dialog, nicht zusätzlich das Menü darunter
  window.addEventListener('keydown', function (e) {
    if (!openEl) return;
    if (e.key === 'Escape') {
      e.stopPropagation();
      if (openEl === hint) remember(curLang);
      if (openEl === conf) { confirmCurrent(); return; }
      close(openEl);
      return;
    }
    if (e.key !== 'Tab') return;
    // Fokus im offenen Dialog halten
    var list = focusables(openEl);
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !openEl.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !openEl.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }, true);

  // ── Länder-Pop-up „Land & Sprache bestätigen“ (#p-lconf) ─────────────────────────────
  function markConfirmed(token) {
    try { localStorage.setItem(CONF_KEY, token + '|' + new Date().toISOString().slice(0, 10)); } catch (e) {}
    try { sessionStorage.setItem(CONF_KEY, token); } catch (e) {}
  }
  function lsAvailable() {
    try { localStorage.setItem('p-loc-test', '1'); localStorage.removeItem('p-loc-test'); return true; } catch (e) { return false; }
  }
  function isConfirmed() {
    try { if (localStorage.getItem(CONF_KEY)) return true; } catch (e) {}
    try { if (sessionStorage.getItem(CONF_KEY)) return true; } catch (e) {}
    return false;
  }

  var params = new URLSearchParams(location.search);
  if (params.get('loc_reset')) {
    try { localStorage.removeItem(CONF_KEY); localStorage.removeItem(KEY); sessionStorage.removeItem(CONF_KEY); } catch (e) {}
  }
  // Bestätigung über Domainwechsel: Token nur übernehmen, wenn Shopify wirklich dort gelandet ist
  var handoff = params.get('p_lconf');
  if (handoff) {
    var parsed = parseConfirmToken(handoff);
    // Shopify entfernt ?country beim Domainwechsel: Markt per einmaligem Reload mit ?country setzen lassen
    if (parsed && parsed.country !== curCountry && !params.get('p_lconf_r')) {
      params.set('country', parsed.country);
      params.set('p_lconf_r', '1');
      location.replace(location.pathname + '?' + params.toString() + location.hash);
      return;
    }
    if (handoff === confirmToken(curCountry, curLang)) { markConfirmed(handoff); remember(curLang); }
    params.delete('country');
  }
  if (handoff || params.get('p_lconf_r')) {
    params.delete('p_lconf');
    params.delete('p_lconf_r');
    var qs = params.toString();
    history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }

  function startConfirm() {
    var testParam = new URLSearchParams(location.search).get('loc_test');
    var forced = !!testParam;
    var testParts = forced ? testParam.split(':') : [];
    var base = {
      forced: forced,
      designMode: conf.getAttribute('data-design-mode') === 'true',
      bot: isBot(navigator.userAgent) || navigator.webdriver === true,
      excluded: isExcludedPath(location.pathname),
      confirmed: isConfirmed(),
      dachHost: conf.getAttribute('data-dach-host') === 'true',
      detected: null,
    };
    // Schnell-Ausstieg ohne Netzwerk (bestätigt oder ausgeschlossen); die IP-Abfrage braucht es nur, wenn es danach noch zählt
    // Ohne localStorage: pro Sitzung nur einmal zeigen (außer bei loc_test)
    if (!forced && !lsAvailable()) { try { if (sessionStorage.getItem(SHOWN_KEY)) return; } catch (e) {} }
    if (base.designMode || base.bot || base.excluded || (base.confirmed && !forced)) return;

    var urlCountry = new URLSearchParams(location.search).get('country');
    detectCountry(forced ? testParts[0] : null).then(function (detected) {
      base.detected = detected;
      if (!shouldShow(base)) return;
      prepare({
        urlCountry: urlCountry,
        detected: detected,
        navLangs: forced && testParts[1] ? [testParts[1]] : (navigator.languages || [navigator.language || '']),
      });
    });
  }

  function detectCountry(testCountry) {
    if (testCountry) return Promise.resolve(testCountry.toUpperCase());
    var DET_KEY = 'p-loc-detected';
    try { var cached = sessionStorage.getItem(DET_KEY); if (cached !== null) return Promise.resolve(cached || null); } catch (e) {}
    var store = function (c) { try { sessionStorage.setItem(DET_KEY, c || ''); } catch (e) {} return c; };
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 3000);
    return fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=false', ctrl ? { signal: ctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        clearTimeout(timer);
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        return store(c ? String(c).toUpperCase() : null);
      })
      .catch(function () { clearTimeout(timer); return null; });
  }

  var cfgEl = conf && conf.querySelector('[data-p-lconf-map]');
  var cfgRaw = { text: '', published: [] };
  try { if (cfgEl) cfgRaw = JSON.parse(cfgEl.textContent) || cfgRaw; } catch (e) {}
  var langCfg = parseCountryLanguages(cfgRaw.text, cfgRaw.published);
  var langCfgAll = parseCountryLanguages(cfgRaw.text, null);
  var roots = {};
  try { roots = JSON.parse(conf ? conf.getAttribute('data-roots') : '{}') || {}; } catch (e) {}
  var freeAmounts = {};
  try { freeAmounts = JSON.parse(conf ? conf.getAttribute('data-free') : '{}') || {}; } catch (e) {}
  var countrySel = conf && conf.querySelector('#p-lconf-country');
  var langSel = conf && conf.querySelector('#p-lconf-lang');
  var langTpl = conf && conf.querySelector('template[data-p-lconf-langs]');
  var localTexts = {};
  try { localTexts = JSON.parse(conf.querySelector('[data-p-lconf-i18n]').textContent); } catch (e) {}
  var textCache = {};
  textCache[curLang] = localTexts;
  var lastTexts = localTexts;

  function available() {
    return Array.prototype.map.call(countrySel.options, function (o) { return o.value; });
  }

  // Auf der DACH-Domain listet Shopify nur die Sprachen des deutschen Marktes → für Auslandsländer die ungefilterte Einstellung nutzen
  function langsFor(country) {
    var all = conf.getAttribute('data-dach-host') === 'true' && !isDachCountry(country);
    return languagesFor(country, all ? langCfgAll : langCfg);
  }

  function endonym(code) {
    var n = code;
    try { n = new Intl.DisplayNames([code], { type: 'language' }).of(code) || code; } catch (e) {}
    return n.charAt(0).toUpperCase() + n.slice(1);
  }

  function fillLanguages(country, preferred) {
    var langs = langsFor(country);
    langSel.innerHTML = '';
    langs.forEach(function (code) {
      var opt = langTpl.content.querySelector('option[value="' + code + '"]');
      if (opt) { langSel.appendChild(opt.cloneNode(true)); return; }
      var made = document.createElement('option');
      made.value = code;
      made.setAttribute('data-code', localeCode(code));
      made.setAttribute('lang', localeCode(code));
      made.textContent = endonym(code);
      langSel.appendChild(made);
    });
    var pick = preferred && langs.indexOf(preferred) > -1 ? preferred : langs[0];
    if (pick) langSel.value = pick;
  }

  function loadTexts(lang) {
    if (textCache[lang]) return Promise.resolve(textCache[lang]);
    var langRoot = roots[lang];
    // Sprache auf dieser Domain nicht verfügbar (z. B. Polnisch auf puschies.de) → Englisch, sonst aktuelle Sprache
    if (!langRoot) return lang !== 'en' && roots.en ? loadTexts('en') : Promise.resolve(localTexts);
    return fetch(langRoot.replace(/\/?$/, '/') + '?sections=p-lang-hint', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var tpl = document.createElement('template');
        tpl.innerHTML = (j && j['p-lang-hint']) || '';
        var s = tpl.content.querySelector('[data-p-lconf-i18n]');
        var t = s ? JSON.parse(s.textContent) : localTexts;
        textCache[lang] = t;
        return t;
      })
      .catch(function () { return localTexts; });
  }

  function money(amount, currency, lang) {
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: currency, maximumFractionDigits: amount % 1 ? 2 : 0 }).format(amount); }
    catch (e) { return amount + ' ' + currency; }
  }

  function render(texts) {
    lastTexts = texts;
    var country = countrySel.value;
    var opt = countrySel.options[countrySel.selectedIndex];
    var names = texts.countries || {};
    var name = names[country] || (opt ? opt.textContent.trim() : country);
    Array.prototype.forEach.call(countrySel.options, function (o) { if (names[o.value]) o.textContent = names[o.value]; });
    var elsewhere = conf.getAttribute('data-dach-host') === 'true' ? !isDachCountry(country) : isDachCountry(country);
    var title = elsewhere ? fillTemplate(texts.title_location, { country: name }) : texts.title;
    var titleEl = conf.querySelector('[data-p-lconf-title]');
    titleEl.textContent = title;
    conf.querySelector('.p-loc__panel').setAttribute('lang', texts.lang || curLang);
    var sub = conf.querySelector('[data-p-lconf-sub]');
    sub.setAttribute('lang', curLang);
    if (texts.lang && texts.lang !== curLang) {
      sub.textContent = elsewhere ? fillTemplate(localTexts.title_location, { country: (localTexts.countries && localTexts.countries[country]) || name }) : localTexts.title;
      sub.hidden = false;
    } else { sub.hidden = true; }
    conf.querySelector('[data-p-lconf-text]').textContent = texts.text;
    conf.querySelector('[data-p-lconf-t="country"]').textContent = texts.country;
    conf.querySelector('[data-p-lconf-t="language"]').textContent = texts.language;
    conf.querySelector('[data-p-lconf-ok]').textContent = texts.button;
    conf.querySelector('[data-p-lconf-other]').textContent = texts.other;
    conf.querySelector('[data-p-lconf-note]').textContent = texts.note;
    conf.querySelector('.p-loc__panel').setAttribute('aria-label', texts.label);
    var currency = opt ? opt.getAttribute('data-currency') : '';
    var symbol = opt ? opt.getAttribute('data-symbol') : '';
    conf.querySelector('[data-p-lconf-currency]').textContent =
      fillTemplate(texts.currency, { currency: symbol && symbol !== currency ? symbol + ' (' + currency + ')' : currency });
    var free = freeShipping({ country: country, currency: currency, amounts: freeAmounts });
    var freeEl = conf.querySelector('[data-p-lconf-free]');
    if (free) { freeEl.textContent = fillTemplate(texts.free_shipping, { amount: money(free.amount, free.currency, texts.lang || curLang) }); freeEl.hidden = false; }
    else freeEl.hidden = true;
    // Flagge aus dem Flaggen-Raster übernehmen (dort für jedes Lieferland gerendert)
    var flagSrc = modal.querySelector('[data-p-loc-country="' + country + '"] svg');
    var flagBox = conf.querySelector('[data-p-lconf-flag]');
    if (flagSrc) { flagBox.innerHTML = ''; flagBox.appendChild(flagSrc.cloneNode(true)); }
  }

  function refreshTexts() {
    var lang = langSel.value;
    return loadTexts(lang).then(function (t) { if (langSel.value === lang) render(t); });
  }

  function prepare(o) {
    var country = pickConfCountry({ urlCountry: o.urlCountry, detected: o.detected, current: curCountry, available: available() });
    countrySel.value = country;
    var lang = pickLanguage({ langs: langsFor(country), pageLang: curLang, navLangs: o.navLangs });
    fillLanguages(country, lang);
    countrySel.addEventListener('change', function () {
      fillLanguages(countrySel.value, pickLanguage({ langs: langsFor(countrySel.value), pageLang: curLang, navLangs: o.navLangs }));
      refreshTexts();
    });
    langSel.addEventListener('change', refreshTexts);
    var shown = false;
    var retryTimer = null;
    var go = function () {
      if (shown) return;
      // Nicht über einem anderen offenen Fenster (Warenkorb-Drawer, Menü, Flaggen-Raster): genau ein Wiederholungs-Timer, ohne Limit
      if (openEl || document.querySelector('dialog[open]')) {
        if (!retryTimer) retryTimer = setTimeout(function () { retryTimer = null; go(); }, 1000);
        return;
      }
      shown = true;
      try { sessionStorage.setItem(SHOWN_KEY, '1'); } catch (e) {}
      confPrevFocus = document.activeElement;
      open(conf, conf.querySelector('[data-p-lconf-ok]'));
    };
    refreshTexts().then(go, go);
    setTimeout(go, 3000);
  }

  function confirmCurrent() {
    markConfirmed(confirmToken(curCountry, curLang));
    remember(curLang);
    close(conf);
  }

  function confirmSelection() {
    var country = countrySel.value;
    var opt = langSel.options[langSel.selectedIndex];
    var lang = opt ? opt.value : curLang;
    var code = opt ? opt.getAttribute('data-code') : curLang;
    var token = confirmToken(country, lang);
    markConfirmed(token);
    remember(lang);
    if (country === curCountry && lang === curLang) { close(conf); return; }
    var q = new URLSearchParams(location.search);
    ['loc_test', 'loc_reset', 'country', 'p_lconf'].forEach(function (k) { q.delete(k); });
    q.set('p_lconf', token);
    form.elements.country_code.value = country;
    form.elements.language_code.value = code;
    var alternates = Array.prototype.map.call(document.querySelectorAll('link[rel="alternate"][hreflang]'), function (l) {
      return { hreflang: l.getAttribute('hreflang'), href: l.href };
    });
    form.elements.return_to.value = targetPath({ alternates: alternates, lang: lang, fallbackPath: location.pathname }) + '?' + q.toString();
    form.submit();
  }

  // Sprach-Hinweis (alt): nur wenn Liquid ihn ausgegeben hat (Pop-up aus) und noch nie beantwortet
  function startHint() {
    if (!hint || remembered()) return;
    if (remembered() || openEl) return;
    var shown = false;
    var go = function () { if (!shown && !openEl) { shown = true; open(hint); } };
    // Überschrift zusätzlich in der Landessprache: dieselbe locales-Übersetzung, von Shopify in dieser Sprache gerendert
    var baseUrl = (hint.getAttribute('data-root') || '/').replace(/\/?$/, '/');
    var foreign = hint.querySelector('[data-p-lhint-foreign]');
    var local = hint.querySelector('.p-lhint__local');
    fetch(baseUrl + '?sections=p-lang-hint', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j['p-lang-hint'];
        if (!html) return;
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var el = tpl.content.querySelector('[data-p-lhint-text]');
        var txt = el ? el.textContent.trim() : '';
        if (txt && txt !== local.textContent.trim()) { foreign.textContent = txt; foreign.hidden = false; }
      })
      .catch(function () {})
      .then(go);
    setTimeout(go, 2500);
  }

  var later = function () { setTimeout(conf ? startConfirm : startHint, 1000); };
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
})();
